<template>
  <div class="con-bk">
    
    <div class="top-img"></div>
   
    
    <div class="con-1400">
      <!-- 导航菜单 -->
      
      <div class="con-menu">
        <el-menu
          router 
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          background-color="#ffffff"
          text-color="#444444"
          active-text-color="#ffffff"
        >
          <el-menu-item index="/">
            <i class="el-icon-arrow-right"></i>
            <span slot="title">首页</span>
          </el-menu-item>
          <el-menu-item index="/menu/trend">
            <i class="el-icon-arrow-right"></i>
            <span slot="title">年度新趋势</span>
          </el-menu-item>
          <el-menu-item index="/menu/performance">
            <i class="el-icon-arrow-right"></i>
            <span slot="title">年度新业绩</span>
          </el-menu-item>
          <el-menu-item index="/menu/appear">
            <i class="el-icon-arrow-right"></i>
            <span slot="title">年度新上市</span>
          </el-menu-item>
          <el-menu-item index="/menu/product">
            <i class="el-icon-arrow-right"></i>
            <span slot="title">年度新产品</span>
          </el-menu-item>
          
          <el-menu-item index="/menu/scheme">
            <i class="el-icon-arrow-right"></i>
            <span slot="title">年度新方案</span>
          </el-menu-item>
          <el-menu-item index="/menu/strategy">
            <i class="el-icon-arrow-right"></i>
            <span slot="title">年度新战略</span>
          </el-menu-item>
        </el-menu>
        <div class="WeChat">
             <img src="../assets/img/wx.jpg" alt="">
             <p>深圳市中安网络技术有限公司版权所有Copyright © 1999-2021 中安网</p>
        </div>
      </div>
     
      <!-- 显示内容 -->
     
      <div class="con-content" >
        <transition>
          <keep-alive>
            <router-view class="router"></router-view>
          </keep-alive>
        </transition>
      </div>
      
    </div>
    
   
  </div>
</template>

<script>
export default {
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/mt.less";
</style>
<style  >
.top-img {
  width: 100%;
  min-width: 1100px;
  height: 140px;
  background-image: url(../assets/img/details-img.jpg);
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  position: fixed;
  top: 0;
  z-index: 10;
}
.con-bk {
  height: 100%;
  width: 100%;
  background-color: rgb(243, 245, 247);
}

/* 中间内容 */
.con-1400 {
  width: 1440px;
  margin: 0 auto;
  margin-top: 140px;
}
.con-1400 div{
  display: inline-block;
}
/* 导航菜单 */
.con-menu {
  width: 260px;
  /* height: 100%; */
  height: 1000px;
  background-color: #ffffff;
  margin-right: 40px;
  float: left;
  position: fixed;
}
.el-menu-item.is-active {
background: linear-gradient(90deg, #FA1D80, #3712B2);
}
.el-menu-vertical-demo{
  width: 210px;
  margin: 0 auto;
  border-right: 0;
  border-bottom: 1px solid #ECECEC;
}
.el-menu-vertical-demo li{
  height: 40px;
  line-height: 40px;
  margin: 25px 0px;
  font-size: 16px;
}
.con-content {
  width: 1140px;
  float: left;
  margin-top: 10px;
}
.WeChat{
  /* width: 260px; */
  margin: 0 auto;
}
.WeChat img{
display: block;
margin: 30px auto;
}
.WeChat p{
  width: 200px;
  margin: 0 auto;
  text-align: center;
  font-size: 12px;
  color: #666666;
     
       padding: 0 1%;
    position: fixed;
    bottom: 20px;
}

</style>


// WEBPACK FOOTER //
// src/components/menu.vue